function TopInfo(){
    return(<>
            <div className="max-width-set">
        <p className="top-title-1 text-center my-5 themeColor">
        Supercharge Marketing and Training with Our 3D Toolkit.
        </p>
        <p className="top-title-2 text-center my-3 mx-2 my-md-5 mx-md-5">
        Each Toolkit includes a custom interactive 3D Model and intuitive Player to visualize and configure your views. Seamlessly integrated with an Augmented Reality (AR) experience, a wealth of digital resources and managed within a unified web-based platform.
        </p>
        <div className="feature-top-info top-push d-flex justify-content-center align-content-center flex-wrap mx-5">

          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\model-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
              Model Library
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\animation-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            Animations
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\annotation-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            Annotations
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\ar-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            AR View
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\360-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            360 Rotate View
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\cutout-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            Cut Out View
            </span>
          </div>
          <div className="card-top-info m-3">
            <img height="50px" src="assets\color-icon\exploted-icon-color.svg" alt="icon"/>
            <span className="name-top-info-1 mx-1">
            Exploded View
            </span>
          </div>

        </div>
        {/* <p className="top-title-3 text-center my-5 mx-5">
        Buyer, seller, student, or Instructor - Launch 3D experience in Web-based 3D or in Augmented Reality (AR), from any device, overlaying a digital twin of your product in your space
        </p> */}
        </div>
    </>)
}

export default TopInfo;